export default __webpack_public_path__ + "static/cardImg1-f62770b6d4eecb65373e1b7a5ff2f68d.webp";